import React from 'react'

function Footer() {
  return (
    <footer className='flex mb-0 bottom-0 items-center justify-center w-auto  h-12 dark:bg-gray-700'>
      <div className='font-bold font-sans text-gray-800 dark:text-white text-sm'>
     Copyright © 2025 - 2026, Satyam Jha
      </div>
    </footer>
  )
}

export default Footer